<script setup lang="ts">
const { t } = useI18n()

const components = [
    resolveComponent('ConfirmationIntro'),
    resolveComponent('ConfirmationInstructions'),
    resolveComponent('ConfirmationInfos'),
]

// Seo
useSeoMeta({
    titleTemplate: () => `%s - ${t('title')}`,
    title: () => t('confirmation.title')
})
</script>

<template>
    <PageMainContainer>
        <template v-for="(component) in components" :key="component">
            <component :is="component" />
        </template>
    </PageMainContainer>
</template>
